/** @flow */

import type { State } from "@store/reducers";
import type { FocusListsType } from "@modules/reporting/reducer/focus-lists/types";
import type {
  DepartmentReport,
  ReportCharts,
  DepartmentReportViewState,
  EffectiveParameters,
} from "@modules/reporting/reducer/focus-lists/department/types";

export type GetReportDetails = (state: State) => DepartmentReport;
export type GetReportCharts = (state: State) => ReportCharts;

export const getDepartmentFocusLists = (
  state: State,
): $PropertyType<FocusListsType, "department"> => state.reporting.focusLists.department;

export const getReport = (state: State): Object => getDepartmentFocusLists(state).report;

export const getReportData = (state: State): Object[] => getReport(state).reportData || [];

export const getEffectiveParameters = (state: State): ?EffectiveParameters =>
  getReport(state).effectiveParameters;

export const getCharts = (state: State): ReportCharts => getReport(state).charts;

export const getReportDetails = (state: State): DepartmentReport => getReport(state).details;

export const isLoading = (state: State): boolean =>
  state.reporting.focusLists.department.report.requestsInProgress > 0;

export const isReportGenerateInProgress = (state: State): boolean => {
  return state.reporting.focusLists.department.report.reportGenerateInProgress > 0;
};

export const getViewState = (state: State): DepartmentReportViewState =>
  state.reporting.focusLists.department.report.viewState;

export const getDepartmentProfile = (state: State): Object =>
  state.reporting.focusLists.department.report.departmentProfile;
